import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { sepolia, base } from "wagmi/chains";

export const config = getDefaultConfig({
  appName: "My RainbowKit App",
  projectId: "c0953bae09893a15c7b1b482dfe4cad5",
  chains: [sepolia, base],
  ssr: false, // If your dApp uses server side rendering (SSR)
});
